import React, { useEffect, useState } from 'react';
import {
  TextField,
  Button,
  CircularProgress,
  Paper,
  Typography,
  Select,
  MenuItem,
  InputLabel
} from '@mui/material';

import { sendNotification } from '../../actions/orderActions';
import { newNotification } from '../../actions/uiActions';
import { connect } from 'react-redux';

import { logToDatadog } from '../../services/datadog';
import {
  getActiveNotifications,
  getTargetNotificationOptions,
  getReachCountForNotificationType
} from 'actions/productActions';

const CELLS = {
  1: 'ORANMORE',
  2: 'BALBRIGGAN',
  7: 'BLANCHARDSTOWN',
  8: 'PECAN_SQUARE',
  16: 'ESPOO'
};

const PUSH_NOTIFICATION_TYPES = [
  'STORES_OPEN',
  'SPECIAL_OFFER',
  'ORDER_STATUS_UPDATE',
  'TARGET'
];

const Notifications = ({ notify, cells, sendNotification, cellId }) => {
  const [notificationBody, setNotificationBody] = useState('');
  const [notificationTitle, setNotificationTitle] = useState('');
  const [sendingText, setSendingText] = useState(false);
  const [notificationReachNumber, setNotificationReachNumber] = useState(-1);
  const [todaysNotifs, setTodaysNotifs] = useState([]);
  const [loadingNotifs, setLoadingNotifs] = useState(true);

  const [pushNotifType, setPushNotifType] = useState(
    PUSH_NOTIFICATION_TYPES[0]
  );
  const [targetNotif, setTargetNotif] = useState('');

  const [
    pushNotificationTypeOptions,
    setPushNotificationTypeOptions
  ] = useState([]);
  const [
    loadingNotificationTypeOptions,
    setLoadingNotificationTypeOptions
  ] = useState(true);

  useEffect(() => {
    setLoadingNotifs(true);
    refreshNotifs();
    refreshNotificationTypeOptions();
    const getNotifsInterval = setInterval(refreshNotifs, 5000);
    return () => {
      clearInterval(getNotifsInterval);
    };
  }, [cellId, refreshNotificationTypeOptions, refreshNotifs]);

  useEffect(() => {
    setNotificationReachNumber(-1);
    if (pushNotifType === 'TARGET') {
      getReachCountForNotificationType(cellId, targetNotif)
        .then(num => setNotificationReachNumber(num))
        .catch(e => {
          logToDatadog(
            'error fetching estimated notification reach',
            { error: e, targetNotif },
            'ERROR'
          );
        });
    }
  }, [pushNotifType, targetNotif, cellId]);

  const refreshNotifs = async () => {
    try {
      const notifs = await getActiveNotifications(cellId);
      setTodaysNotifs(notifs);
      setLoadingNotifs(false);
    } catch (err) {
      console.log(err);
    }
  };

  const refreshNotificationTypeOptions = async () => {
    try {
      const notifOptions = await getTargetNotificationOptions();
      setPushNotificationTypeOptions(notifOptions);
      setLoadingNotificationTypeOptions(false);

      // Use the first option as default target audience:
      if (targetNotif === '' && notifOptions.length > 0)
        setTargetNotif(notifOptions[0].displayName);
    } catch (err) {
      console.log(err);
    }
  };

  const send = async () => {
    const cellName = cells?.find(cell => cell.id === cellId)?.cellName || CELLS[cellId];

    // Only show target audience if using target mode:
    const targetConfirmText =
      pushNotifType === 'TARGET' ? `, Target: ${targetNotif})` : '';

    const yesSend = window.confirm(
      `Do you want to send this text: (Type: ${pushNotifType}${targetConfirmText} Title: ${notificationTitle} Body: ${notificationBody} to ${cellName}`
    );

    if (yesSend) {
      try {
        setSendingText(true);
        sendNotification({
          title: notificationTitle,
          body: notificationBody,
          pushNotifType: pushNotifType,
          targetNotif: targetNotif,
          cellName
        });
        setSendingText(false);
      } catch (err) {
        setSendingText(false);
        notify({ variant: 'error', message: 'Failed to send messages' });
      }
    }
  };

  const onChangeNotificationBody = evt => {
    setNotificationBody(evt.target.value);
  };

  const onChangeNotificationTitle = evt => {
    setNotificationTitle(evt.target.value);
  };

  return (
    <Paper style={{ padding: 15, marginTop: 25 }}>
      <h3
        style={{
          fontSize: 20,
          fontFamily: 'Arial',
          marginBottom: 20,
          marginTop: 10
        }}>
        Todays Notifications {!loadingNotifs && `(${todaysNotifs.length})`}
      </h3>
      <div style={{ overflowX: 'auto', width: '100%' }}>
        {!loadingNotifs &&
          todaysNotifs.map(notif => {
            return (
              <Paper
                key={notif.id}
                style={{
                  padding: 20,
                  marginRight: 20,
                  marginBottom: 20,
                  marginLeft: 3,
                  width: 400,
                  display: 'inline-block'
                }}>
                <h3 style={{ fontSize: 20, fontFamily: 'Arial' }}>
                  {notif.title}
                </h3>
                <Typography>{notif.body}</Typography>
                <div
                  style={{
                    borderBottom: '1px solid #efefef',
                    marginTop: 10,
                    marginBottom: 10
                  }}></div>
                <Typography>Sent Successfully: {notif.sentSuccess}</Typography>
                <Typography>Failed to send: {notif.sentFailed}</Typography>
              </Paper>
            );
          })}
        {!loadingNotifs && todaysNotifs.length === 0 && (
          <Typography>No notifications sent today</Typography>
        )}
        {loadingNotifs && (
          <div
            style={{
              padding: 30,
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center'
            }}>
            <CircularProgress />
          </div>
        )}
      </div>

      <h3
        style={{
          fontSize: 20,
          fontFamily: 'Arial',
          marginBottom: 20,
          marginTop: 30
        }}>
        New Notification
      </h3>
      <InputLabel
        id="push-notif-type-label"
        style={{ marginBottom: '10px', fontWeight: '600' }}>
        Push Notification Type
      </InputLabel>
      <Select
        labelId="push-notif-type"
        id="push-notif-type"
        value={pushNotifType}
        variant="outlined"
        style={{ width: '100%', marginBottom: 15 }}
        onChange={e => {
          setPushNotifType(e.target.value);
        }}
        placeholder="Push Notification Type">
        {PUSH_NOTIFICATION_TYPES.map((o, i) => (
          <MenuItem value={o} key={`${o}-${i}`}>
            {o}
          </MenuItem>
        ))}
      </Select>
      {pushNotifType === 'TARGET' && (
        <Select
          labelId="push-notif-target-select"
          id="push-notif-target-select"
          disabled={loadingNotificationTypeOptions}
          value={targetNotif}
          variant="outlined"
          style={{ width: '100%', marginBottom: 15 }}
          onChange={e => {
            setTargetNotif(e.target.value);
          }}
          placeholder="Push Notification Type">
          {!loadingNotificationTypeOptions &&
            pushNotificationTypeOptions.map((o, i) => (
              <MenuItem key={`${o.displayName}-${i}`} value={o.displayName}>
                <Typography display="inline">{o.displayName}</Typography>
                <Typography
                  display="inline"
                  style={{ color: '#546e7a', fontSize: 11, marginLeft: 6 }}>
                  {o.description ? `(${o.description})` : ''}
                </Typography>
              </MenuItem>
            ))}
        </Select>
      )}
      <TextField
        style={{ width: '100%', marginBottom: 15 }}
        label="Notfication Title"
        variant="outlined"
        onChange={onChangeNotificationTitle}
        value={notificationTitle}
      />
      <TextField
        style={{ width: '100%' }}
        label="Notfication Body"
        value={notificationBody}
        multiline
        rows={10}
        variant="outlined"
        onChange={onChangeNotificationBody}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={send}
        disabled={sendingText || !notificationBody || !notificationTitle}
        startIcon={sendingText ? <CircularProgress size={10} /> : null}>
        Send Notification
      </Button>
      {notificationReachNumber >= 0 ? (
        <Typography style={{ marginTop: 6 }}>
          Estimated reach: {notificationReachNumber} people.
        </Typography>
      ) : (
        <></>
      )}
    </Paper>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  notify: notification => dispatch(newNotification(notification)),
  sendNotification: notif => dispatch(sendNotification(notif))
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
